var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlamat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.297,
    height: 45,
    viewBox: "0 0 35.297 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.229 -280.596)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.229 280.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.944,298.244c0,9.747-14.545,27.278-17.648,27.278-2.822,0-17.648-17.531-17.648-27.278a17.648,17.648,0,0,1,35.3,0Z",
    transform: "translate(-2.648 -280.596)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.163,11.532C16.438,17.014,13.136,21.806,7.79,25.577a4.093,4.093,0,0,0,1.952,1.065c1.98,0,8.608-7.117,13.161-14.814A1.566,1.566,0,0,0,20.163,11.532Z",
    transform: "translate(7.945 18.359)",
    fill: "#a29292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.448,283.539H23.8a2.241,2.241,0,0,1,2.246,2.246v15.452a2.241,2.241,0,0,1-2.246,2.246H7.448A2.241,2.241,0,0,1,5.2,301.237V285.785A2.241,2.241,0,0,1,7.448,283.539Z",
    transform: "translate(2.025 -275.211)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,283.539V289.5a1.053,1.053,0,0,0,1.056,1.054H11.97a1.053,1.053,0,0,0,1.056-1.054v-5.961Z",
    transform: "translate(7.137 -275.211)",
    fill: "#eae8e8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.256 17.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,286.9a.75.75,0,0,0,.072,1.5H9.782a.749.749,0,1,0,0-1.5Z",
    transform: "translate(-6.254 -286.898)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.021,288.066a.749.749,0,1,0,0,1.5h5.427a.749.749,0,1,0,0-1.5Z",
    transform: "translate(-6.272 -284.761)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.852,289.711a1.5,1.5,0,0,0-1.127,2.481H21.688a2.241,2.241,0,0,0,2.246-2.246v-.235Z",
    transform: "translate(-6.119 -281.751)",
    fill: "#ff9700"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlamat);
export default __webpack_public_path__ + "static/media/alamat.1dc614a09f1380ae123929c76d5565dc.svg";
export { ForwardRef as ReactComponent };